import { MemberFormSchema } from "@factory/form/form.rule";
import { GetMemberModel } from "@factory/model/query-model-member";

export class MemberFormMap {
  static Map(model: GetMemberModel) {
    return {
      firstName: model.first_name,
      lastName: model.last_name,
      photo: model.fileBlob,
      gender: model.gender,
      email: model.email,
      mobileNumber: model.mobile_number,
      birthday: model.birthday,
    } as MemberFormSchema;
  }
}
